import { Component, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error?: Error };

export class ErrorBoundary extends Component<Props, State> {
  state: State = {};
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: any) {
    // why: surface to console + leave room for Sentry later
    console.error("[ErrorBoundary]", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 16, color: "#0f172a", fontFamily: "Inter, system-ui", background:"#ffffff" }}>
          <h2>Something went wrong.</h2>
          <pre style={{ whiteSpace: "pre-wrap" }}>{String(this.state.error.stack ?? this.state.error.message)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
